import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentPlansService {

  private _baseUrl: string = '';
  private _controllerName: string = '';

  constructor(private _http: HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = 'PaymentPlans';
  }

  getAllocations(paymentPlanId: number): Observable<any> {
    return this._http
      .get<any>(`${this._baseUrl}/${this._controllerName}/${paymentPlanId}/allocations`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene los payment plans pendientes de una inscripción individual
   */
  getPendingPaymentsByEnrollment(enrollmentId: number): Observable<any> {
    return this._http
      .get<any>(`${this._baseUrl}/${this._controllerName}/enrollment/${enrollmentId}/pending`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene los corporate payment plans pendientes de una inscripción corporativa
   */
  getPendingCorporatePaymentPlans(corporateEnrollmentId: number): Observable<any> {
    return this._http
      .get<any>(`${this._baseUrl}/${this._controllerName}/corporate-enrollment/${corporateEnrollmentId}/pending`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene los corporate payment plans pendientes de la empresa (PayerType = COMPANY)
   */
  getPendingCompanyPaymentPlans(corporateEnrollmentId: number): Observable<any> {
    return this._http
      .get<any>(`${this._baseUrl}/${this._controllerName}/corporate-enrollment/${corporateEnrollmentId}/pending/company`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene los corporate payment plans pendientes de un participante específico (PayerType = PARTICIPANT)
   */
  getPendingParticipantPaymentPlans(corporateEnrollmentId: number, participantId: number): Observable<any> {
    return this._http
      .get<any>(`${this._baseUrl}/${this._controllerName}/corporate-enrollment/${corporateEnrollmentId}/pending/participant/${participantId}`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * Historial versionado del plan de pagos (incluye versiones inactivas).
   */
  getHistory(enrollmentId: number, type: 'individual' | 'corporate' = 'individual'): Observable<any> {
    return this._http
      .get<any>(`${this._baseUrl}/${this._controllerName}/history/${enrollmentId}?type=${type}`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Snapshot del plan ACTIVO para edición — incluye cuotas PAID y PARTIALLY_PAID
   * con sus recibos asociados. Reemplaza a `getPendingPayments` cuando la pantalla
   * necesita mostrar el plan completo.
   *
   * @param type 'individual' | 'corporate-company' | 'corporate-participant'
   */
  getEditableSnapshot(
    enrollmentId: number,
    type: 'individual' | 'corporate-company' | 'corporate-participant' = 'individual',
    participantId?: number
  ): Observable<any> {
    let url = `${this._baseUrl}/${this._controllerName}/enrollment/${enrollmentId}/editable-snapshot?type=${type}`;
    if (participantId != null) url += `&participantId=${participantId}`;
    return this._http.get<any>(url).pipe(catchError(this.handleErrors));
  }

  private handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log('Ocurrió un error', error.error.message);
    } else {
      console.log(`${error.status}, ${error.error}`);
      return throwError(() => new Error(`Ocurrió un error ${error.status}, ${error.error}`));
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }
}


